import { CollectionState } from '../collection-state.interface';
import { initialState } from './initial-state';

const getDefaultCollectionId = (state: CollectionState) => {
  if (!state.defaultCollectionId) {
    return undefined;
  }

  const defaultCollection = state.listOfCollections.find(
    (collection) => collection.collectionId === state.defaultCollectionId,
  );

  return defaultCollection ? defaultCollection.collectionId : undefined;
};

const onStoreInit = (state: CollectionState) => ({
  ...initialState,
  ...state,
  defaultCollectionId: getDefaultCollectionId(state),
});

export default onStoreInit;
